<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card>
            <v-card-title>
                <span class="headline">Edit Quest</span>
            </v-card-title>
            <v-card-text>
                <span>UID: {{ model.uid }}</span>
                <v-text-field label="Name:" v-model.trim="model.name" hide-details class="mt-3"/>
                <v-text-field label="Key:" v-model.trim="model.key" hide-details class="mt-3"/>
                <v-expansion-panels class="mt-4">
                    <r-guard-panel :model.sync="model.guard" title="Guard"/>
                    <r-reward-panel :model.sync="model.reward" title="Rewards"/>
                    <r-trigger-panel :items.sync="model.triggersComplete" title="Triggers - Complete"/>
                </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="red darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="green darken-1" class="white--text">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import VueTypes from "vue-types";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel";
import RTriggerPanel from "@/modules/redactor/views/trigger/r-trigger-panel";
import RDifficulty from "@/modules/redactor/views/utils/r-difficulty.vue";
import RDailyQuestDropdown from "@/modules/redactor/views/daily-quest/r-daily-quest-dropdown.vue";
import {SmartOfferBundleNoviceBattlePassDayQuest} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDayQuest";

export default {
    name: "r-smart-offer-bundle-novice-battle-pass-quest-edit-dialog",
    components: { RDifficulty, RGuardPanel, RRewardPanel, RTriggerPanel, RDailyQuestDropdown},
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        model: VueTypes.objectOf(SmartOfferBundleNoviceBattlePassDayQuest),
    }),
    methods: {
        show(quest_model) {

            this.dialog = true;
            this.model = quest_model || new SmartOfferBundleNoviceBattlePassDayQuest();

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config!");
            }
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        }
    }
};
</script>
